import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(private _messageService: MessageService) {}

  //eslint-disable-next-line
  private _handleHttpErrorResponse(err: HttpErrorResponse) {
    //TODO message w zaleznosci od kodu;

    const messageTitle = $localize`Wystąpił błąd`;
    this._messageService.add({
      key: 'error-message',
      severity: 'error',
      summary: messageTitle,
      closable: true,
      life: 2000,
    });
  }
  showError(err: HttpErrorResponse) {
    if (err instanceof HttpErrorResponse)
      return this._handleHttpErrorResponse(err);
  }
}
